import {Component, Injector, Input, OnInit} from '@angular/core';
import {DynamicBarService} from "../../../_components/dynamic-bar/dynamic-bar.service";


@Component({
    selector: 'nivelaciones-citacion-mcp-barra',
    standalone: false,
    template: `
        <div class="header-mainInfo">
            <a class="control-item" [routerLink]="['/nivelaciones']" title="Ir a estudio">Nivelaciones</a>
            <span class="header-mainInfo__separator">/</span>
            <h1 class="">{{curso}}</h1>
            <span class="spacer"></span>
        </div>`
})

export class NivelacionesCitacionMcpBarraComponent implements OnInit {

    curso: string;

    constructor(private injector: Injector,
                private dynamicBarService: DynamicBarService) {
    }

    ngOnInit() {
        this.curso = this.injector.get('curso');
    }
}